import {announce} from '@github-ui/aria-live'
import {UnsafeHTMLBox} from '@github-ui/safe-html/UnsafeHTML'
import {testIdProps} from '@github-ui/test-id-props'
import {useAnalytics} from '@github-ui/use-analytics'
import {Banner} from '@primer/react'
import {useEffect} from 'react'

import {Strings} from './constants/strings'
import styles from './ValidationMessage.module.css'

interface ValidationMessageProps {
  id: string
  messages?: string[]
}

export const ValidationMessage = ({id, messages}: ValidationMessageProps) => {
  const {sendAnalyticsEvent} = useAnalytics()
  useEffect(() => {
    if (messages && messages.length > 0) {
      const userFriendlyMessage = messages
        .map(s => s.replaceAll(/<pre>|<\/pre>/g, "'"))
        .join('. ')
        .trim()
      const announcement = `${Strings.filterInvalid(messages.length)} ${userFriendlyMessage}.`
      announce(announcement)
      sendAnalyticsEvent('filter.validation_errors', 'FILTER_VALIDATION_ERRORS', {messages: userFriendlyMessage})
    }
  }, [sendAnalyticsEvent, messages])

  if (!messages || messages.length < 1) return null

  return (
    <Banner id={id} variant="warning" className={styles.Banner}>
      <Banner.Title>
        <span {...testIdProps('validation-error-count')}>{Strings.filterInvalid(messages.length)}</span>
      </Banner.Title>
      <div className={styles.Box_0}>
        <ul className={styles.Box_2} {...testIdProps('validation-error-list')}>
          {/* We are setting the HTML dangerously below in order to have <pre> tags show up as HTML properly */}
          {messages.map(message => (
            <UnsafeHTMLBox
              as="li"
              key={message.replaceAll(' ', '-')}
              html={message}
              domPurifyConfig={{ALLOWED_TAGS: ['pre']}}
              className={styles.VerifiedHTMLBox_0}
            />
          ))}
        </ul>
      </div>
    </Banner>
  )
}

try{ ValidationMessage.displayName ||= 'ValidationMessage' } catch {}